import React, { useEffect, useContext, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import "./common.css";
import { AuthContext } from "../helpers/AuthContext";
import Loading from './Loading';

function RTRL() {

  const svgStyle = {
    height: '150px',
    width: '250px',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const tileStyle = {
    margin: '10px',
    flexBasis: 'calc(20%)', // 4 tiles per row, adjusting for margins
    padding:"0"
  };

  let history = useHistory();
  const { authState } = useContext(AuthContext);
  const [tileAllowed, setTileAllowed] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://rt-rl-api.aajkaa.in/auth/auth", {
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then((response) => {
      if (response.data.error) {
        history.push('/login');
        return;
      }
      axios.post("https://rt-rl-api.aajkaa.in/Usertypes/getallowedtilename", authState, {
        headers: { accessToken: localStorage.getItem("accessToken") },
      }).then((response) => {
        setTileAllowed(response.data[0]);
        setLoading(false);
      });
    });
  }, [authState, history]);

  return (
    <div>
      <div className="mx-5">
        <div className="row mt-3" style={{padding:"0px"}}>
          {loading ? (
            <Loading />
          ) : (
            <div style={containerStyle}>
              {tileAllowed && tileAllowed.newenquiry == 1 && (
                <Link to="/Newenquiry" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#EF597B" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#EF597B" }} />
                      <text x="65" y="80" fill="red" fontSize="30">Enquiry</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.vehicalstatus == 1 && (
                <Link to="/Vehicalstatus" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#FF6D31" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#FF6D31" }} />
                      <text x="65" y="60" fill="red" fontSize="30">Vehicle</text>
                      <text x="70" y="95" fill="red" fontSize="30">Status</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.masterlist == 1 && (
                <Link to="/Masterlist" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#29A2C6" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#29A2C6" }} />
                      <text x="70" y="60" fill="red" fontSize="30">Master</text>
                      <text x="85" y="95" fill="red" fontSize="30">Lists</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.wanverification == 1 && (
                <Link to="/Wanverification" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#FFCB18" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#FFCB18" }} />
                      <text x="80" y="60" fill="red" fontSize="30">WAN</text>
                      <text x="40" y="95" fill="red" fontSize="30">Verification</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.financialaccounting == 1 && (
                <Link to="/Financialaccounting" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#EF597B" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#EF597B" }} />
                      <text x="60" y="60" fill="red" fontSize="30">Financial</text>
                      <text x="40" y="95" fill="red" fontSize="30">Accounting</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.messaging == 1 && (
                <Link to="/Messageing" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#73B66B" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#73B66B" }} />
                      <text x="45" y="80" fill="red" fontSize="30">Messaging</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.reports == 1 && (
                <Link to="/Report" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#FF6D31" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#FF6D31" }} />
                      <text x="65" y="80" fill="red" fontSize="30">Reports</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.adminmodule == 1 && (
                <Link to="/Adminmodule" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#29A2C6" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#29A2C6" }} />
                      <text x="70" y="60" fill="red" fontSize="30">Admin</text>
                      <text x="65" y="95" fill="red" fontSize="30">Module</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.assetmanagement == 1 && (
                <Link to="/Assetmanagement" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#FFCB18" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#FFCB18" }} />
                      <text x="75" y="60" fill="red" fontSize="30">Asset</text>
                      <text x="25" y="95" fill="red" fontSize="30">Management</text>
                    </svg>
                </Link>
              )}
              {tileAllowed && tileAllowed.closedcase == 1 && (
                <Link to="/Closedcase" className="btn" style={tileStyle}>
                    <svg style={svgStyle}>
                      <polygon points="0,0,110,0,10,10,0,110" style={{ fill: "#EF597B" }} />
                      <polygon points="230,140,230,30,220,130,120,140" style={{ fill: "#EF597B" }} />
                      <text x="65" y="60" fill="red" fontSize="30">Closed</text>
                      <text x="75" y="95" fill="red" fontSize="30">Cases</text>
                    </svg>
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RTRL;

// import React, { useEffect, useContext, useState } from 'react'
// import { Link, useHistory } from "react-router-dom";
// import axios from "axios";
// import "./common.css"
// import { AuthContext } from "../helpers/AuthContext";
// import Loading from './Loading'


// function RTRL() {
//   let history = useHistory();
//   const { authState } = useContext(AuthContext);
//   const [tileAllowed, setTileAllowed] = useState()
//   const [loading, setLoading] = useState(true)


//   useEffect(() => {
//     axios.get("https://rt-rl-api.aajkaa.in/auth/auth", {
//       headers: { accessToken: localStorage.getItem("accessToken") },
//     }).then((response) => {
//       if (response.data.error) {
//         history.push('/login')
//         return
//       }
//       console.log("Response data:", response.data); // Log the response data
//       axios.post("https://rt-rl-api.aajkaa.in/Usertypes/getallowedtilename", authState, {
//         headers: { accessToken: localStorage.getItem("accessToken") },
//       }).then((response) => {
//         setTileAllowed(response.data[0])
//         console.log("Tile allowed:", response.data[0]); // Log the tile allowed data
//         setLoading(false)
//       });
//     });
//   }, [authState])
//   return (
//     <div>
//       <div className="mx-5">
//         <h2 className='text-primary text-center my-4'>Welcome to Ravindra Logistics</h2>
//         <div className="row mx-2 mt-3">
//           {loading ? (
//             <Loading />
//           ) : (
//             <>
//               {tileAllowed && tileAllowed.newenquiry == 1 && <Link to="/Newenquiry" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>New Enquiry</div></Link>}
//               {tileAllowed && tileAllowed.existingenquiry == 1 && <Link to="/Existingenquiry" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Existing Enquiry</div></Link>}
//               {tileAllowed && tileAllowed.vehicalstatus == 1 && <Link to="/Vehicalstatus" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Vehicle Status</div></Link>}
//               {tileAllowed && tileAllowed.masterlist == 1 && <Link to="/Masterlist" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Master Lists</div></Link>}
//               {tileAllowed && tileAllowed.wanverification == 1 && <Link to="/Wanverification" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>WAN Verification</div></Link>}
//               {tileAllowed && tileAllowed.financialaccounting == 1 && <Link to="/Financialaccounting" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Financial Accounting</div></Link>}
//               {tileAllowed && tileAllowed.messaging == 1 && <Link to="/Messageing" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Messaging</div></Link>}
//               {tileAllowed && tileAllowed.reports == 1 && <Link to="/Report" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Reports</div></Link>}
//               {tileAllowed && tileAllowed.adminmodule == 1 && <Link to="/Adminmodule" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Admin Module</div></Link>}
//               {tileAllowed && tileAllowed.assetmanagement == 1 && <Link to="/Assetmanagement" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Asset Management</div></Link>}
//               {tileAllowed && tileAllowed.closedcase == 1 && <Link to="/Closedcase" className="btn col-md-3 border tile_hover"><div className='text-center' style={{fontSize:"1.8vw"}}>Closed Cases</div></Link>}
//             </>
//           )}
//         </div>
//       </div>
//     </div >
//   );
// }

// export default RTRL
